import PropTypes from 'prop-types'

const Metric = ({ name, value }) => (
  <div className='col-6 col-sm-5'>
    <h3 className='mc-text-color--primary mc-text-h8 mc-text--uppercase'>
      {name}
    </h3>
    <span className='mc-text-large d-block mc-mt-2'>{value}</span>
  </div>
)

Metric.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
}

export default Metric
